import React, { useEffect, useState } from 'react'
import { getAuthToken } from '../api/auth';
import { getData } from '../utils/local-storage-helper';

export const AppContexte = React.createContext()


export const GlobalApp  = ({children}) =>{

    const [token, setToken] = useState(null);

    useEffect(() => {
        const fetchToken = async () => {
            const authToken = await getAuthToken();
            setToken(authToken);
        };
        fetchToken();
    }, []);

    const[endPoint, setEndPoint]= useState('')
    const[section, setSection]= useState('WELCOME')
    const[decodedToken, setDecodedToken]= useState()
    const[max, setMax]= useState(getData('sidebar')?.toString()?getData('sidebar'):true)

    useEffect(() => {
        setDecodedToken(token ? JSON.parse(atob(token.token?.split('.')[1])) : "")
    }, [token]);



    let update = {
        endPoint: endPoint,
        setEndPoint: setEndPoint,

        section: section,
        setSection: setSection,

        decodedToken: decodedToken,
        setDecodedToken: setDecodedToken,

        max: max,
        setMax: setMax,
    }

    return(
        <AppContexte.Provider value={update}>
            {children}
        </AppContexte.Provider>
    )
}